var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#F5FAFD","position":"relative"}},[(_vm.$route.meta.isEmbed)?_c('dashboard-selector'):_vm._e(),_c('tracker-dashboard-filters'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }